export const OPEN_NEW_TICKET_ID = 'open-new-ticket';
export const MAXIMUM_ACTIVE_PANELS = 1;
